export default __webpack_public_path__ + "static/media/logo-attomo.ae9b81ec.svg";